const theme = {
    primary: '#ff6363',
    textPrimary: '#404040',
    textSecondary: '#808080',
    background: '#fafafa'
};

export default theme;
